import { useEffect, useState, useContext } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import { UserContext } from '../context/UserContext';
import PhoneVerification from './PhoneVerification';
import CustomerInfoForm from './CustomerInfoForm';
import PaymentMethod from './PaymentMethod';
import OrderSummary from './OrderSummary';
import '../styles/main.css';
import { trackInitiateCheckout, trackPurchase } from '../utils/fbPixel';
import GoBackButton from './GoBackButton';

export default function Checkout() {
    const navigate = useNavigate();
    const { clearCart, cartItems } = useContext(CartContext);
    const { state: locationState } = useLocation();
    const { businessName, salePointName } = useParams();
    const { user, setUser } = useContext(UserContext);

    const [verified, setVerified] = useState(false);
    const [orderDetails, setOrderDetails] = useState(null);
    const [salePointArabicName, setSalePointArabicName] = useState(''); 
    const [customerInfo, setCustomerInfo] = useState({
        custName: '',
        phoneNumber: user?.name || '',
        address: '',
        state: '',
        district: ''
    });
    const [paymentType, setPaymentType] = useState("");
    const [selectedState, setSelectedState] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState('');

    // useEffect(() => {
    //     if (!verified || !locationState?.items || locationState.items.length === 0) return;

    //     fetch(`/api/checkout/${businessName}/${salePointName}/checkout-details`, {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify(locationState.items)
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             setOrderDetails(data);
    //             setSalePointArabicName(data.salePointArabicName || '');


    //             console.log("Here is the data checkout-details  ",data.salePointArabicName)

    //         })
    //         .catch(err => console.error('Failed to fetch checkout details', err));
    // }, [verified, locationState, businessName, salePointName]);

    useEffect(() => {
    if (!verified || !locationState?.items || locationState.items.length === 0) return;

    // Track InitiateCheckout event when checkout page loads with cart items
    if (locationState?.items && locationState.items.length > 0) {
        // Use the full cart items with price information if available
        if (cartItems && cartItems.length > 0) {
            console.log('Tracking InitiateCheckout with full cart items:', cartItems);
            trackInitiateCheckout(cartItems);
        } else {
            // Fallback to locationState.items if cartItems is not available
            console.log('Tracking InitiateCheckout with locationState.items:', locationState.items);
            trackInitiateCheckout(locationState.items);
        }
    }

    fetch(`/api/checkout/${businessName}/${salePointName}/checkout-details`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(locationState.items)
    })
        .then(res => {
            if (!res.ok) {
                throw new Error('Response not OK');
            }
            return res.json();
        })
        .then(data => {
            if (!data || !data.items || !Array.isArray(data.items)) {
                throw new Error('Invalid data format');
            }
            setOrderDetails(data);
            setSalePointArabicName(data.salePointArabicName || '');
        })
        .catch(err => {
            console.error('Failed to fetch checkout details', err);
            navigate('/not-found', { replace: true });
        });
}, [verified, locationState, businessName, salePointName, navigate, cartItems]);


    useEffect(() => {
        const storedPhone = localStorage.getItem('userPhone');
        const isVerified = localStorage.getItem('isVerified');

        if (storedPhone && isVerified === "true") {
            setVerified(true);
            if (!user) {
                setUser({ name: storedPhone });
            }
        }
    }, [user, setUser]);

    const handleVerificationComplete = (phoneNumber) => {
        setVerified(true);
        setUser({ name: phoneNumber });
        localStorage.setItem('isVerified', 'true');
        localStorage.setItem('userPhone', phoneNumber);
    };

    const handlePlaceOrder = () => {
        // Track Purchase event when order is placed
        if (orderDetails) {
            const order = {
                id: new Date().getTime().toString(), // Generate a unique order ID
                total: orderDetails.total,
                items: orderDetails.items
            };
            trackPurchase(order);
        }

        clearCart();
        navigate(`/${businessName}/${salePointName}`, { replace: true });
    };

    if (!verified) {
        return (
            <PhoneVerification
                onVerificationComplete={handleVerificationComplete}
                initialPhone={user?.name || ''}
                isVerified={verified}
                businessName={businessName}
                salePointName={salePointName}
            />
        );
    }

    return (
        <div className="checkout-container">
          
           <h1 className="checkout-title">عملية الشراء من متجر {salePointArabicName}</h1>

            <CustomerInfoForm
                phoneNumber={user?.name || ''}
                businessName={businessName}
                salePointName={salePointName}
                onStateChange={(state) => setCustomerInfo(prev => ({ ...prev, state }))}
                onDistrictChange={(district) => setCustomerInfo(prev => ({ ...prev, district }))}
                onCustomerInfoChange={(info) => setCustomerInfo(prev => ({ ...prev, ...info }))}
                initialValues={customerInfo}
            />

            <PaymentMethod
                onPaymentMethodChange={setPaymentType}
            />

            <OrderSummary
                items={orderDetails?.items || []}
                total={orderDetails?.total || 0}
                onPlaceOrder={handlePlaceOrder}
                businessName={businessName}
                salePointName={salePointName}
                customerInfo={customerInfo}
                paymentType={paymentType}
                cartItems={locationState?.items || []}
            />
        </div>
    );
}
